// extracted by css-extract-rspack-plugin
export default {"article":"_dc7fdcb3","stacked":"_e4bdc278","articleElement":"_4ee23b2d","header":"_f2f4ec8","body":"_c1d67c07","hidden":"_a91facfd","featuredImg":"_9c0c6d84"};